import { defineComponent as _defineComponent } from 'vue'
import { UserDB } from '@/enitites/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileStats',
  props: {
    user: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})